import { Injectable } from '@angular/core';
import { Observable, map, of } from 'rxjs';

import { DconConfigAPI } from '../config/config';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { DataService } from '../config/data.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigBuildService {
  nodeBaseUrl = DconConfigAPI.NODE_URL;
  token = localStorage.getItem('authToken');

  constructor(private https: HttpClient, private _data: DataService) {}

  getConfigBuildModulesData(project_id: any): Observable<any> {
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.GET_MODULE_DETAILS;

    const payLoad = { projectId: project_id };

    if (environment.isBasicAuth) {
      const headers = new HttpHeaders({
        Authorization: `Bearer ${this.token}`,
      });

      payLoad['isBasicAuth'] = true;

      return this.https.post(url, payLoad, { headers });
    }

    return this.https.post(url, payLoad);
  }

  getConfigBuildModulesToTaskData(config_module_id: string): Observable<any> {
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.MODULES_TO_TASK;

    const payLoad = { moduleId: config_module_id };

    if (environment.isBasicAuth) {
      const headers = new HttpHeaders({
        Authorization: `Bearer ${this.token}`,
      });

      payLoad['isBasicAuth'] = true;

      return this.https.post(url, payLoad, { headers });
    }

    return this.https.post(url, payLoad);
  }

  downloadExcelFile(project_id: string): Observable<Blob> {
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.DOWNLOAD_XLSX_FILE;

    const payload = { projectId: project_id };

    if (environment.isBasicAuth) {
      const headers = new HttpHeaders({
        Authorization: `Bearer ${this.token}`,
      });

      payload['isBasicAuth'] = true;

      return this.https.post<Blob>(url, payload, {
        headers,
        responseType: 'blob' as 'json',
      });
    }

    return this.https.post<Blob>(url, payload, {
      responseType: 'blob' as 'json',
    });
  }

  // completeModule(module_id: string): Observable<any> {
  //   return this.https.patch(`${this.nodeBaseUrl}/api/complete-config-tasks/`, {
  //     module_id,
  //   });
  // }

  completeTask(
    task_id: string,
    module_id: string,
    task_status: number
  ): Observable<any> {
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.TASK_STATUS;

    const payload = {
      isTaskComplete: task_status,
      taskId: task_id,
      moduleID: module_id,
      isModuleComplete: 1,
      completedBy: this._data.loggedUserId,
    };

    if (environment.isBasicAuth) {
      const headers = new HttpHeaders({
        Authorization: `Bearer ${this.token}`,
      });

      payload['isBasicAuth'] = true;

      return this.https.put(url, payload, { headers });
    }

    return this.https.put(url, payload);
  }
}
